import React from 'react';
import TextWorks from '../components/TextWorks';





function Works() {
    return (
        <div id="works">
                <TextWorks/>
        </div>


    );
}

export default Works;